/**
 * Hero plus the product plate. The plate keeps its 16:8 frame whether or
 * not the clip has landed, so nothing reflows while it loads — and the
 * poster-less dark frame matches the video's own letterboxing.
 */
import { useState } from 'react'

export default function Hero() {
  const [missing, setMissing] = useState(false)

  return (
    <>
      <section className="lp-hero">
        <h1 className="lp-h1">The intelligent engine for defense acquisition.</h1>
        <p className="lp-hero__lede">Turn capability gaps into fielded capabilities.</p>
        <div className="lp-hero__actions">
          <a href="#demo" className="lp-btn lp-btn--solid">Request a demo</a>
          <a href="#engine" className="lp-btn lp-btn--outline">See how it works</a>
        </div>
      </section>

      <section className="lp-shot">
        <div className={`lp-shot__frame${missing ? ' lp-shot__frame--empty' : ''}`}>
          {missing ? (
            <span className="lp-shot__caption">
              PRODUCT UI — AGENT WORKSPACE, PROGRAM VIEW [TBD]
            </span>
          ) : (
            <video
              src="/hero-agent-workspace.mp4"
              autoPlay
              loop
              muted
              playsInline
              aria-label="The Overmatch agent workspace, showing a program view"
              onError={() => setMissing(true)}
            />
          )}
        </div>
      </section>
    </>
  )
}
